module.exports = __webpack_public_path__ + "img/punctedelucru.542bca18.svg";